import {_get} from "@api/doinsport/services/httpService";
import { URL_CLIENT } from "../index";

const URI = '/family';

export const getClientFamily = (clientId) => _get(URL_CLIENT + '/' + clientId + URI );
